import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import { PermissionChecker } from '../../session'
import Container from '../../../components/structure/Container'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from './PageHeader'
import AddNewButton from './AddNewButton'
import DynamicServiceOrdersLoader from './_load/DynamicServiceOrdersLoader'
import DynamicServiceOrdersTable from './table/DynamicServiceOrdersTable'
import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import ShareFormModal from './share/ShareDynamicServiceOrderModal'
import ShareDynamicServiceOrderContext from './share/_context/ShareDynamicServiceOrderContext'

const DynamicServiceOrdersListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listDynamicServiceOrder">
        <Container>
          <PageHeader />
          <FilterHandler>
            <ControlBar />
            <MultiSelectHandler>
              <ShareDynamicServiceOrderContext>
                <DynamicServiceOrdersLoader uncontrolledChildren={<MultiRowsActions />}>
                  <DynamicServiceOrdersTable />
                </DynamicServiceOrdersLoader>
                <ShareFormModal />
              </ShareDynamicServiceOrderContext>
            </MultiSelectHandler>
          </FilterHandler>
          <AddNewButton />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default DynamicServiceOrdersListPage
